export const GET_FRAUD_ORDERS_START = 'GET_FRAUD_ORDERS_START';
export const GET_FRAUD_ORDERS_SUCCESS = 'GET_FRAUD_ORDERS_SUCCESS';
export const GET_FRAUD_ORDERS_FAILED = 'GET_FRAUD_ORDERS_FAILED';

export const UPDATE_FRAUD_ORDER_STATUS_START = 'UPDATE_FRAUD_ORDER_STATUS_START';
export const UPDATE_FRAUD_ORDER_STATUS_SUCCESS = 'UPDATE_FRAUD_ORDER_STATUS_SUCCESS';
export const UPDATE_FRAUD_ORDER_STATUS_FAILED = 'UPDATE_FRAUD_ORDER_STATUS_FAILED';

export const getFraudOrdersStart = () => ({
  type: GET_FRAUD_ORDERS_START
});

export const getFraudOrdersSuccess = (data) => ({
  type: GET_FRAUD_ORDERS_SUCCESS,
  data
});

export const getFraudOrdersFailed = (error) => ({
  type: GET_FRAUD_ORDERS_FAILED,
  error
});

export const updateFraudOrderStatusStart = () => ({
  type: UPDATE_FRAUD_ORDER_STATUS_START
});

export const updateFraudOrderStatusSuccess = (data) => ({
  type: UPDATE_FRAUD_ORDER_STATUS_SUCCESS,
  data
});

export const updateFraudOrderStatusFailed = (error) => ({
  type: UPDATE_FRAUD_ORDER_STATUS_FAILED,
  error
});
